import * as yup from "yup";

// const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const phoneRegExp = /^[0-9]{10}$/;
yup.addMethod(yup.string, "customPhoneValidation", function (errorMessage) {
  return this.test(`test-card-length`, errorMessage, function (value) {
    if (value) {
      return value.match(phoneRegExp) ? true : false;
    } else {
      return true;
    }
  });
});

yup.addMethod(yup.string, "customMatch", function (errorMessage, input) {
  return this.test(`test-card-length`, errorMessage, function (value) {
    if (value) {
      if (input === "email") {
        return this.parent.email !== value;
      } else {
        return this.parent.number !== value;
      }
    }
    return true;
  });
});

export const defaultValues = {
  name: "",
  shopName: "",
  email: "",
  number: "",
  pdCity: "",
  pdCountry: "",
  isPremium: false,
  userID: "",
  commission: "",
  location: null,

  storeDescriptionHeading: "",
  storeDescription: "",
  sellerDescriptionHeading: "",
  sellerDescription: "",
  deliveryDays: "",
  deliveryMethodName: "",
  deliveryTime: "",
  otherInformationHeading: "",
  otherInformation: "",
  returnDays: "",
  refundDays: "",
  sellerSince: "",
  otherPolicyHeading: "",
  otherPolicy: "",

  minOrder: "",
  deliveryInfo: "",
  chargeTax: false,
  socialFacebook: "",
  socialTwitter: "",
  socialInstagram: "",
  instagramWidgetCode: "",
  shippingOption: 1,

  returnCancellationPolicyHeading: "",
  returnCancellationPolicy: "",
  sellerProfileHeading: "",
  sellerProfileLink: "",
  sellerShopHeading: "",
  sellerShopLink: "",
  brandSizeChartHeading: "",
  brandSizeChartLink: "",
  sizeChartHeading: "",
  sizeChartLink: "",
  promotionHeading: "",
  promotionLink: "",
  tradeShowHeading: "",
  tradeShowLink: "",
  designedMadeInHeading: "",
  designedMadeInLink: "",
  shippingValidityHeading: "",
  shippingValidityLink: "",

  customerFullName: "",
  customerMobileNumber: "",
  customerEmail: "",

  returnsFirstAddress: "",
  returnsCity: "",
  returnsCountry: "",
  returnsPostcode: "",

  storeName: "",
  apiKey: "",
  apiSecretKey: "", // NEW
  secretKey: "",
};

/**
 * Form Validation Schema
 */

const urlRegex =
  /^(?!https?:\/\/)(?!www\.)[a-zA-Z0-9-.]+\.([a-zA-Z]{2,}\.)?[a-zA-Z]{2,}$/;

export const schema = yup.object().shape({
  // Legal Name <= 40
  name: yup
    .string()
    .required("Name is required field")
    .max(40, "Legal Name must be 40 characters or less"),

  shopName: yup.string().required("Shop Name is required field"),
  email: yup
    .string()
    .email()
    .required("Email is required field")
    .typeError("Please enter valid mail"),
  number: yup
    .string()
    .required("Phone number is required field")
    .customPhoneValidation("Invalid phone number"),
  pdCity: yup.string().nullable(),
  isPremium: yup.bool().nullable(),
  pdCountry: yup
    .object()
    .required("Country is required field")
    .typeError("Please select country"),
  location: yup
    .number()
    .required("Location is required field")
    .typeError("Please select location"),
  // commission: yup.number().required('Commission is a required field').typeError('Please enter valid input for Commission'),

  storeDescriptionHeading: yup.string().nullable(),
  storeDescription: yup.string().required("Store Description is required field"),
  sellerDescriptionHeading: yup.string().nullable(),
  sellerDescription: yup.string().required("Store Description is required field"),
  deliveryDays: yup.string().nullable(),
  deliveryMethodName: yup.string().nullable(),
  deliveryTime: yup.string().nullable(),
  otherInformationHeading: yup.string().nullable(),
  otherInformation: yup.string().nullable(),
  returnDays: yup.number().nullable(),
  refundDays: yup.number().nullable(),
  sellerSince: yup.string().required("Seller Since is required field"),
  otherPolicyHeading: yup.string().nullable(),
  otherPolicy: yup.string().required("Other Policy is required field"),

  minOrder: yup
    .number()
    .required("Minimum order is required field")
    .typeError("Please enter valid input for minimum order"),
  deliveryInfo: yup.string().nullable(),
  chargeTax: yup.bool().nullable(),
  socialFacebook: yup.string().nullable(),
  socialTwitter: yup.string().nullable(),
  socialInstagram: yup.string().nullable(),
  instagramWidgetCode: yup.string().nullable(),
  shippingOption: yup
    .string()
    .required("Shipping Option Description is required field"),

  returnCancellationPolicyHeading: yup.string().nullable(),
  returnCancellationPolicy: yup.string().nullable(),
  sellerProfileHeading: yup.string().nullable(),
  sellerProfileLink: yup.string().nullable(),
  sellerShopHeading: yup.string().nullable(),
  sellerShopLink: yup.string().nullable(),
  brandSizeChartHeading: yup.string().nullable(),
  brandSizeChartLink: yup.string().nullable(),
  sizeChartHeading: yup.string().nullable(),
  sizeChartLink: yup.string().nullable(),
  promotionHeading: yup.string().nullable(),
  promotionLink: yup.string().nullable(),
  tradeShowHeading: yup.string().nullable(),
  tradeShowLink: yup.string().nullable(),
  designedMadeInHeading: yup.string().nullable(),
  designedMadeInLink: yup.string().nullable(),
  shippingValidityHeading: yup.string().nullable(),
  shippingValidityLink: yup.string().nullable(),

  customerFullName: yup.string().nullable(),
  customerEmail: yup.string().nullable().email("Please enter valid mail"),
  customerMobileNumber: yup
    .string()
    .nullable()
    .customPhoneValidation("Invalid Phone number"),

  returnsFirstAddress: yup
    .string()
    .required("Address is required field")
    .typeError("Address is required field")
    .test("returnsFirstAddress-before-after-last-comma", "Invalid Address", function (value) {
        const raw = (value ?? "");
        const v = raw.trim();
        if (!v) return false;

        if (v.endsWith(",")) {
        return this.createError({
            message: "Address must not end with a comma",
        });
        }

        const lastCommaIndex = v.lastIndexOf(",");

        if (lastCommaIndex === -1) {
        if (v.length > 40) {
            return this.createError({
            message:
                "Address must not exceed 40 characters. If you need to add more details, use a comma to separate the address into two parts.",
            });
        }
        return true;
        }

        const beforeLastComma = v.substring(0, lastCommaIndex).trim();
        const afterLastComma = v.substring(lastCommaIndex + 1).trim();

        if (beforeLastComma.length > 40) {
        return this.createError({
            message:
            "Before the last comma, we consider it as Address Line 1 and it should not exceed 40 characters. Please shorten the first part of the address.",
        });
        }

        if (afterLastComma.length > 40) {
        return this.createError({
            message:
            "After the last comma, we consider it as Address Line 2 and it should not exceed 40 characters. Please shorten the part after the last comma.",
        });
        }

        return true;
  }),

  returnsCity: yup
    .string()
    .required("City/Town is required field")
    .typeError("City/Town is required field")
    .max(40, "City/Town must be 40 characters or less"),

  returnsCountry: yup
    .object()
    .required("Country is required field")
    .typeError("Country is required field"),

  returnsPostcode: yup
    .string()
    .required("Postcode is required field")
    .typeError("Postcode is required field")
    .max(10, "Postcode must be 10 characters or less"),

  // Shopify Details - NOW MANDATORY
  storeName: yup
    .string()
    .required("Store Name is required field")
    .test(
      "is-url",
      "Please enter a valid URL without https, http, or www. and with a valid domain extension like .com, .lk, .uk, etc.",
      (value) => {
        return !!value && urlRegex.test(value);
      }
    ),
  apiKey: yup.string().required("API Key is required field"),
  apiSecretKey: yup.string().required("API Secret Key is required field"),
  secretKey: yup.string().required("Password/Access Token is required field"),
});